import VillaCard from "@/components/Card/VillaCard";
import React from "react";

const VillaItem = ({ index, style, data }) => {
  const villa = data[index];

  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "flex-start",
      }}
    >
      <div className="flex-shrink-0 sm:w-full ml:w-[300px] w-[290px]">
        <VillaCard villa={villa} />
      </div>
    </div>
  );
};

export default VillaItem;
